import type HandlerViewState from '../store/schema/HandlerViewState';
import type AnnotationHandler from '../store/schema/AnnotationHandler';
import type AugLoopViewState from '../store/schema/AugLoopViewState';
import { trace } from 'owa-trace';

export default function getViewStateForAnnotationHandler(
    handler: AnnotationHandler,
    viewState: AugLoopViewState
): HandlerViewState | undefined {
    try {
        if (viewState?.handlerViewStates?.get) {
            return viewState.handlerViewStates.get(handler.name);
        } else {
            return viewState?.handlerViewStates[handler.name];
        }
    } catch (error) {
        trace.warn(
            `[AugLoopPlugin] exception encountered when getting handler view states: ${error.message}`
        );
    }

    return undefined;
}
